import { NavLink } from 'react-router-dom';

function NavigationMenu() {
  return (
    <div className="flex flex-row space-x-10 bg-gls-logo-blue py-3 px-10 text-xl" style={{ color: '#daffff' }}>
      <div className="hover:underline">
        <a href={window.origin + '/Delivery/RouteSummary'}>Home</a>
      </div>

      <div className="hover:underline">
        <NavLink to="/" className={({ isActive }) => (isActive ? 'font-bold text-white' : '')} end>
          Route Scan Summaries
        </NavLink>
      </div>

      <div className="hover:underline">
        <NavLink to="pickups" className={({ isActive }) => (isActive ? 'font-bold text-white' : undefined)}>
          Pickups
        </NavLink>
      </div>
    </div>
  );
}

export default NavigationMenu;
